import React, { Component } from "react";
import CloseCommand from "../../Commands/CloseCommand/CloseCommand";
import "../../Styles/globalStyle.css";

const Process = (props) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    //api.login(formData.get("email"), formData.get("password"));
  };
  return (
    <div className="simpleFormContainer">
      <div className="rowFormContainer">
        <form>
          <div className="titleRow">
            <div className="titleLeftCol">
              <h3 className="label">Decision</h3>
            </div>
            <div className="titleRightCol">
              <CloseCommand />
            </div>
          </div>

          <div className="bodyRow">
            <label className="label">Wording</label>
            <input type="text" name="libelle" className="input" />
            <label className="label">Description</label>
            <textarea type="text" name="description" className="textarea" />
            <input type="button" className="button" value="Enregistrer" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Process;
